import "./contact.css";
import instagramIcon from "../../assets/instagram.png";
import emailIcon from "../../assets/email.png";
import whatsappIcon from "../../assets/whatsapp.png";
import link from "../../assets/link.png";

const Contact = () => {
  return (
    <div id="contactPage">
      <div id="contact">
        <h1 className="contactPageTitle">Contact Me</h1>
        <span className="contactDesc">
          Let’s connect! Reach out through my social platforms below.
        </span>
        <br></br>


        <div className="links">
          {/* Email */}
          <a href="mailto:pragathisrai9@gmail.com" target="_blank" rel="noreferrer">
            <img src={emailIcon} alt="Email" className="link" />
          </a>


          {/* Linkedib */}
          <a href="https://www.linkedin.com/in/pragathi-s-rao/" target="_blank" rel="noreferrer">
            <img src={link} alt="Linkedin" className="link" />
          </a>

          {/* Instagram */}
          <a href="https://instagram.com/_pragathi9_" target="_blank" rel="noreferrer">
            <img src={instagramIcon} alt="Instagram" className="link" />
          </a>

          {/* WhatsApp */}
          <a href="https://wa.me/918095717320" target="_blank" rel="noreferrer">
            <img src={whatsappIcon} alt="WhatsApp" className="link" />
          </a>

          
        </div>
      </div>
    </div>
  );
};

export default Contact;
